export const WATER_LEVEL_SOURCE_ID = 'water-level';
export const SOURCE_LAYER = 'weatherstations_waterlevel';
export const WATER_LEVEL_LOW_ZOOM_LAYER_ID = 'water-level-low-zoom-layer';
export const WATER_LEVEL_HIGH_ZOOM_LAYER_ID = 'water-level-high-zoom-layer';
export const WATER_LEVEL_NONE_OFFLINE_ICONS_LAYER_ID =
  'water-level-none-offline-icons-layer';
export const WATER_LEVEL_LABELS_LAYER_ID = 'water-level-labels-layer';
export const WATER_LEVEL_SELECTED_PULSE_LAYER_ID =
  'water-level-selected-pulse-layer';
export const MAX_ICON_ZOOM_LEVEL = 10;
export const MIN_NONE_OFFLINE_ICON_ZOOM_LEVEL = 10;
export const MIN_LABEL_ZOOM_LEVEL = 12;

export const BASE_PULSE_CIRCLE_RADIUS_SMALL = 4;
export const BASE_PULSE_CIRCLE_RADIUS_LARGE = 10;
